import { Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NicaMaster } from '../../nica-master-component/nica-master.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from '../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentService } from '../../../services/component.service';
import { FormsTemplateService } from '../../../services/forms-template.service';
import { OverlaySideFormService } from '../../shared/overlay-side-form/overlay-side-form.service';
import { NicaMenuService } from '../../../services/nica-menu.service';
import { RentriService } from '../../../services/rentri.service';
import { AnagraficaService } from '../../../services/anagrafica.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-cer',
  templateUrl: './cer.component.html',
  styleUrls: ['./cer.component.css']
})
export class CerComponent extends NicaMaster implements OnInit {
  @Input() showTitle: boolean = true;
  @Output() rowSelected = new EventEmitter<any>();
  help: any;

  constructor(private activateRoute: ActivatedRoute,
    public spinner: NgxSpinnerService,

    public apiservice: Apiservice,


    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,


  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );
  }


  ngOnInit() {


    this.activateRoute.queryParams.subscribe(params => {
      this.params = params
      this.help = 'CatalogoEuropeoRifiutiCER.html';
      console.log("Parametri=", this.params);


      this.currentTabId = params.currentTabId,
        this.currentTabName = params.currentTabName



      this.setGlobalVariableFromParams(params);


    })

  }
  validateDataFieldPrepared(e: any) {
    console.log("In prepared ", e);
  }



  checkGetAll(e: any) {
    //alert("eccoloooo")
    var exdes = '';
    var exGr = '';
    var exGrDes = '';
    var exSub = '';
    var idCer = '';
    console.log("ecco i cer ", e)

    e.data.forEach(element => {
      //element.gruppo=element.id.substring(0, 4)
      let gr = element.id.substring(0, 4);
      let subGr = element.id.substring(2);

      if (element.id.substring(2) == '0000') {
        element.gruppo = element.descrizione;
        exdes = element.descrizione;
        //          exGr=element.id.substring(0, 4);

      } else
        element.gruppo = exdes
    });
    return e.data;
  }
  emettiChiusuraCaption(e){
    
    this.userComponentService.destroyCurrentOpenPopUp('CerComponent')
    
  }
  AllEvent(e: any) {

    //onInitNewRow
    //onCellPrepared

    if (e.name == "onCellPrepared" && e.rowType == "data") {
      console.log("in onCellPrepared ", e);
      if (e.data.id.substring(2) == '0000') {
        (e.cellElement as HTMLElement).style.border = 'none';
        if (e.dataField == 'id') {
          (e.cellElement as HTMLElement).innerHTML = "<div><strong>" + e.data.descrizione + "</strong></div>";
          (e.cellElement as HTMLElement).style.color = '#222437';
          e.cellElement.colSpan = '3'
        } else (e.cellElement as HTMLElement).innerHTML = ''
      } else
        if (e.data.id.substring(4) == '00') {
          //(e.cellElement as HTMLElement).style.border='none';
          (e.cellElement as HTMLElement).style.borderRight = '1px solid';
          (e.cellElement as HTMLElement).style.borderRightColor = 'white';
          if (e.dataField == 'id') {
            (e.cellElement as HTMLElement).innerHTML = "";
          }
          if (e.dataField == 'descrizione') {
            (e.cellElement as HTMLElement).innerHTML = "<strong>" + e.data.descrizione + "</strong>";
          }
        }

    }

    if (e.name == "onRowPrepared") {

      if (e.rowType == "data") {
        if (e.data.id.substring(2) == '0000') {
          //(e.rowElement as HTMLElement).style.backgroundColor='#a9b3d4';//'#7081b9';

          //border:none
        } else {
          if (e.data.id.substring(4) == '00') {
            //(e.rowElement as HTMLElement).style.backgroundColor='#a9b3d4';
          }
        }
      }
    }


    if (e.name == "onInitNewRow") {
      e.data.pericoloso = false;
      return e;
    }
    if (e.name == "onSaving") {
      let valueCer = e.changes[0].codiceCER;
      console.log("in all events ", valueCer);

    }

    if (e.name == "onSelectionChanged") {
      this.rowSelected.emit(e);
      console.log(e);

    }
    //
  }

}
